<template>
  <section class="py-5 px-3" style="background-color: #eef9f3;"> <!-- Light grey bg -->
    <div class="container">
      <div class="mx-auto p-4 bg-white shadow rounded" style="max-width: 720px;">
        <h1 class="display-6 text-center text-success mb-4" style="font-size: 2rem;"> Safeguarding, Privacy & Policies</h1>

       
        <p class="mb-3" style="font-size: 1.05rem;">
        <strong>We believe that great Computer Science education goes hand in hand with responsibility, safety, and trust. 
        Just as we teach students to design reliable systems, we apply the same principles to how we work with people and data.
        </strong></p>

        <p class="mt-3" style="font-size: 1.05rem;">
        <b>1. Safeguarding</b>
        <b>Our Commitment</b> 
          
          The safety and wellbeing of children and young people is our highest priority.
          We are committed to providing a safe, respectful, and supportive learning environment in all sessions. 
          </p>

           <p class="mt-3" style="font-size: 1.05rem;">
            <b>Online Learning Environment</b>

            <b>All lessons are conducted using approved and secure online platforms.</b>
           
         We ensure that:
            <ul>
            <li>Sessions remain professional and focused on learning</li>
            <li>Communication is appropriate, respectful, and educational</li>
            <li>Students feel safe, supported, and confident to participate</li>
            </ul>
           </p>



           <p class="mt-3" style="font-size: 1.05rem;">
          <b>Reporting Concerns</b>

          <b>Any safeguarding concerns are taken seriously and handled appropriately.</b>
           
          We encourage students, parents, and schools to raise concerns at any time.
          All concerns will be reviewed carefully and acted upon in line with best practice.
          </p>

        <p style="font-size: 1.05rem;">
            <b>Contact (Safeguarding)</b>

          For safeguarding-related matters, please contact:
          email here...
          or use our contact form.
        </p>

      
      </div>
    </div>
  </section>
</template>

